const DEFAULT_PLAYER_COLOR = '#ED8B00';

/**
* Applies custom player color to playcover and other elements
*/
export function applyCustomStyles(presentationId, playCoverData, presentationData) {
    let root = document.documentElement;
    const customColor = playCoverData?.customPlayerColor || presentationData?.playerOptions?.settings?.customPlayerColor;
    if (customColor && customColor !== DEFAULT_PLAYER_COLOR) {
        root.style.setProperty('--playcover-color', customColor);
        root.style.setProperty('--player-primary-color', customColor);
    }
}
